import { getLocalTimeZone as getLocalTimeZone$1 } from '@internationalized/date';

var getLocalTimeZone = function getLocalTimeZone() {
  return getLocalTimeZone$1();
};

export { getLocalTimeZone };